import egumaReact from "egumaReact"; // added in externals in webpack
import React from "react";

class Note extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      note: egumaReact.noteValue
    };
  }

  getNote() {
    return this.state.note;
  }

  renderInput() {
    // elmira / Fine-Dining-Erlebnis
    if (egumaReact.eventId === "6634c62a973b9316789d21a6") {
      var values = [
        "I already knew it",
        "Recommendation from friends/acquaintances",
        "Instagram",
        "TripAdvisor",
        "LinkedIn",
        "Newspaper article / Blog",
        "Google",
        "Guide Michelin",
        "Gault&Millau",
        "Other"
      ];

      if (egumaReact.lang === "de") {
        values = [
          "Kannte ich bereits",
          "Empfehlung durch Freunde/Bekannte",
          "Instagram",
          "TripAdvisor",
          "LinkedIn",
          "Zeitungsartikel / Blog",
          "Google",
          "Guide Michelin",
          "Gault&Millau",
          "Sonstiges"
        ];
      } else if (egumaReact.lang === "fr") {
        values = [
          "Je connaissais déjà",
          "Recommandation de connaissances",
          "Instagram",
          "TripAdvisor",
          "LinkedIn",
          "Article de journal / Blog",
          "Google",
          "Guide Michelin",
          "Gault&Millau",
          "Autre"
        ];
      }

      return (
        <select
          value={this.state.note}
          onChange={e => this.setState({ note: e.target.value })}
          style={{ padding: "5px", marginTop: 3 }}
        >
          <option value=""></option>
          {values.map((value, index) => (
            <option key={index} value={value}>
              {value}
            </option>
          ))}
        </select>
      );
    }

    return (
      <textarea
        value={this.state.note}
        onChange={e => this.setState({ note: e.target.value })}
        cols="41"
        rows="3"
        style={{ height: 50 }}
      ></textarea>
    );
  }

  render() {
    if (!egumaReact.noteEnabled) {
      return <div />;
    }

    return (
      <div style={{ marginTop: 30 }}>
        <div>
          <strong>{egumaReact.noteFieldName}</strong>
        </div>
        {this.renderInput()}
      </div>
    );
  }
}

export default Note;
